import {
    FETCH_LOGIN_REQUEST,
    FETCH_LOGIN_SUCCESS,
    FETCH_Lang_REQUEST,
    FETCH_CONFIRM_ACCOUNT,
    FETCH_SIGNUP_SUCCESS,
    RESET_SIGNUP_SUCCESS
} from "../type";

import axios from "axios";
import { API_ENDPOINT } from '../../../AppConfig';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export function RegisterRequest(data, lang) {
    return (dispatch, getState) => {
        dispatch({ type: FETCH_LOGIN_REQUEST });
        dispatch(showLoading());
        let uri = `${API_ENDPOINT}/signup`;
        axios.post(uri, data, {
            headers: {
                'Accept-Language': lang
            }
        })
            .then(response => {
                let obj = {
                    email: response.data.user.email,
                    type: response.data.user.type
                }
                saveToLocalStorage('sendEmail', JSON.stringify(obj));
                // console.log("response REGISTERATION", response.data)
                saveToLocalStorage('Korasatoken', JSON.stringify(response.data.token));
                saveToLocalStorage('KorasaAppuser', JSON.stringify(response.data.user));
                saveToLocalStorage('KorasauserType', JSON.stringify(response.data.user.type));
                saveToLocalStorage('Language', response.data.user.language);
                // dispatch({ type: FETCH_Lang_REQUEST, payload: response.data.user.language });
                // dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
                dispatch({ type: FETCH_SIGNUP_SUCCESS });
                setTimeout(() => dispatch({ type: RESET_SIGNUP_SUCCESS }) ,3000)
                dispatch(hideLoading());
            }).catch(error => {
                dispatch(hideLoading());
                console.log("Error REGISTERATION", error.response)
                if (!error.response) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                    }));
                } else if (error.response.status === 422) {
                    error.response.data.errors.map((item, index) => {
                        if (item.param === "email") {
                            dispatch(showSnack('myUniqueId', {
                                label: item.msg,
                                timeout: 7000,
                                button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                            }));
                        }
                        if (item.param === 'phone') {
                            dispatch(showSnack('myUniqueId', {
                                label: item.msg,
                                timeout: 7000,
                                button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                            }));
                        }
                        if (item.param === 'type') {
                            dispatch(showSnack('myUniqueId', {
                                label: item.msg,
                                timeout: 7000,
                                button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                            }));
                        }
                        if (item.param === "username") {
                            dispatch(showSnack('myUniqueId', {
                                label: item.msg,
                                timeout: 7000,
                                button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                            }));
                        }
                    })
                    dispatch(hideLoading());

                } else if (error.response.status === 404) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: error.response.data.errors,
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Signup' : 'الاشتراك' }
                    }));
                } else if (error.response.status === 401) {
                    dispatch(hideLoading());
                }
            })
    }
}
export function ConfirmAccount(data, lang) {
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmAccount`;
        axios.put(uri, data, {
            headers: {
                'Accept-Language': lang
            }
        })
            .then(response => {
                console.log("CODECONFIRM res", response.data)
                
                saveToLocalStorage('Korasatoken', JSON.stringify(response.data.token));
                saveToLocalStorage('KorasaAppuser', JSON.stringify(response.data.user));
                saveToLocalStorage('id', JSON.stringify(response.data.user.id));
                saveToLocalStorage('KorasauserType', JSON.stringify(response.data.user.type));
                saveToLocalStorage('Language', response.data.user.language);
                dispatch({ type: FETCH_Lang_REQUEST, payload: response.data.user.language });
                dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
                dispatch({ type: FETCH_CONFIRM_ACCOUNT });
            }).catch(error => {
                // console.log("CODECONFIRM err", error.response)
                if (!error.response) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'confirmation code' : 'كود التأكيد' }
                    }));
                } else if (error.response.status === 404) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: error.response.data.errors,
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'confirmation code' : 'كود التأكيد' }
                    }));
                }
            } )
    }
}

export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
